import { gql } from '@apollo/client';
import { Message } from '../types/messagingCollection';
import performQuery from './contentfulClient';

export const Messaging_QUERY = gql`
  query messagingQuery($slug: String!) {
    ansMessagingCollection(where: { slug: $slug }) {
      items {
        slug
        title
        messageText {
          json
        }
      }
    }
  }
`;

export const useMessagingQuery = async (slug: string) => {
  const response = await performQuery(Messaging_QUERY, { slug });

  if (response.hasError) {
    return {
      data: null,
      error: true,
      errorMsg: response.error,
    };
  }

  return {
    data: response.res?.data?.ansMessagingCollection?.items?.[0] as Message | null,
    error: false,
  };
};
